import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function CTAButton() {
  return <a href="https://mindinfonow.online/vsl-drmw-01?src=advdrmw3" className="bg-red-600 hover:bg-red-700 text-white font-bold py-4 px-8 rounded-md flex items-center justify-center mx-auto shadow-lg transform hover:scale-105 transition-transform duration-200 no-underline" data-id="element-109">
      <span className="text-lg" data-id="element-110">Click Here to Watch</span>
      <ArrowRightIcon size={18} className="ml-2" data-id="element-111" />
    </a>;
}